import { formatReportDate, formatReportTime } from '@/utils/formatters';

const POPPINS_FONT_URL =
  'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap';

/** Injects Poppins stylesheet if needed and waits until the font is ready. Call before PDF capture. */
export function ensurePoppinsLoaded(): Promise<void> {
  const existing = document.getElementById('pdf-poppins-load');
  if (existing) {
    return document.fonts.load('400 1em Poppins').then(() => undefined);
  }
  const link = document.createElement('link');
  link.id = 'pdf-poppins-load';
  link.rel = 'stylesheet';
  link.href = POPPINS_FONT_URL;
  return new Promise<void>(resolve => {
    link.onload = () => {
      document.fonts.load('400 1em Poppins').then(
        () => resolve(),
        () => resolve()
      );
    };
    link.onerror = () => resolve();
    document.head.appendChild(link);
  });
}

/** Copies computed styles from source to clone so PDF does not depend on external stylesheets. */
export function copyComputedStyles(source: Element, target: Element): void {
  if (source.nodeType !== Node.ELEMENT_NODE || target.nodeType !== Node.ELEMENT_NODE) return;
  const src = source as HTMLElement;
  const tgt = target as HTMLElement;
  const computed = window.getComputedStyle(src);
  for (let i = 0; i < computed.length; i++) {
    const prop = computed[i];
    tgt.style.setProperty(
      prop,
      computed.getPropertyValue(prop),
      computed.getPropertyPriority(prop)
    );
  }
  const srcChildren = src.children;
  const tgtChildren = tgt.children;
  for (let i = 0; i < srcChildren.length; i++) {
    if (i < tgtChildren.length) copyComputedStyles(srcChildren[i], tgtChildren[i]);
  }
}

export const levelColors = ['#FF9F4C', '#E11560', '#2BAE19', '#973D9D', '#05ABF4'];

export const timeString = formatReportTime;
export const dateString = formatReportDate;

export const reportSkillsList = [
  { id: 2, name: 'grammar' },
  { id: 3, name: 'speak' },
  { id: 1, name: 'listen' },
  { id: 5, name: 'vocabulary' },
  { id: 7, name: 'read' },
  { id: 4, name: 'spelling' },
];
